export const FETCH_ALLSTUDENTS_REQUEST = 'FETCH_ALLSTUDENTS_REQUEST'
export const FETCH_ALLSTUDENTS_SUCCESS = 'FETCH_ALLSTUDENTS_SUCCESS'
export const FETCH_ALLSTUDENTS_FALIURE = 'FETCH_ALLSTUDENTS_FALIURE'
